export const Permission = [
        {
            "UserId":"00000-0000",
            "UserName" : "Girija",
            "Role": "admin",
            "Menus":[
                {
                    "MenuId" :"m1",
                    "MenuName":"Master",
                    "Parent":"",
                    "ParentId" :""
                },
                {
                    "MenuId" :"m2",
                    "MenuName":"Patient",
                    "Parent":"",
                    "ParentId" :""
                },
                {
                    "MenuId" :"m3",
                    "MenuName":"Account",
                    "Parent":"",
                    "ParentId" :""
                },
                {
                    "MenuId" :"m4",
                    "MenuName":"IPD",
                    "Parent":"",
                    "ParentId" :""
                },
                {
                    "MenuId" :"m3",
                    "MenuName":"OPD",
                    "Parent":"",
                    "ParentId" :""
                },
                {
                    "MenuId" :"m3",
                    "MenuName":"Report",
                    "Parent":"",
                    "ParentId" :""
                }
                ]
            },
            {
            "UserId":"00000-0000",
            "UserName" : "praveen",
            "Role": "admin",
            "Menus":[
                {
                    "MenuId" :"m1",
                    "MenuName":"Master",
                    "Parent":"",
                    "ParentId" :""
                },
                {
                    "MenuId" :"m2",
                    "MenuName":"Patient",
                    "Parent":"",
                    "ParentId" :""
                },
                {
                    "MenuId" :"m3",
                    "MenuName":"Account",
                    "Parent":"",
                    "ParentId" :""
                },
                {
                    "MenuId" :"m4",
                    "MenuName":"IPD",
                    "Parent":"",
                    "ParentId" :""
                },
                {
                    "MenuId" :"m3",
                    "MenuName":"OPD",
                    "Parent":"",
                    "ParentId" :""
                },
                {
                    "MenuId" :"m3",
                    "MenuName":"Report",
                    "Parent":"",
                    "ParentId" :""
                }
                ]
            },
            {
            "UserId":"00000-0000",
            "UserName" : "rajib",
            "Role": "accounts",
            "Menus":[
                
                {
                    "MenuId" :"m3",
                    "MenuName":"Account",
                    "Parent":"",
                    "ParentId" :""
                },
                
                {
                    "MenuId" :"m3",
                    "MenuName":"Report",
                    "Parent":"",
                    "ParentId" :""
                }
                ]
            },
            {
            "UserId":"00000-0000",
            "UserName" : "prasant",
            "Role": "frontoffice",
            "Menus":[
                
                {
                    "MenuId" :"m2",
                    "MenuName":"Patient",
                    "Parent":"",
                    "ParentId" :""
                },
                
                {
                    "MenuId" :"m4",
                    "MenuName":"IPD",
                    "Parent":"",
                    "ParentId" :""
                },
                {
                    "MenuId" :"m3",
                    "MenuName":"OPD",
                    "Parent":"",
                    "ParentId" :""
                },
                {
                    "MenuId" :"m3",
                    "MenuName":"Report",
                    "Parent":"",
                    "ParentId" :""
                }
                ]
            }
]

